import PropTypes from "prop-types";
import doneIconWhite from "assets/icons/doneIconWhite.svg";
import styled from "styled-components";
import { useEffect, useState } from "react";

const Wrapper = styled.div`
  label {
    margin-left: 1.2rem;
    cursor: pointer;
  }
`;

const Box = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  height: 2.4rem;
  width: 2.4rem;
  border: 1px solid ${(props) => (props.checked ? props.color : "#cccccc")};
  border-radius: ${(props) => (props.circle ? "100%" : "4px")};
  background-color: ${(props) => (props.checked ? props.color : "#fff")};
  cursor: pointer;

  input {
    display: none;
  }

  .checkedIcon {
    height: 100%;
    pointer-events: none;
  }
`;

const handleClick = (e, id) => {
  e.stopPropagation();
  const checkboxInput = document.querySelector(`input[type="checkbox"]#${id}`);

  checkboxInput.click();
};

/**
 * CheckBox component for rendering a customizable checkbox.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {string} [props.id] - Unique identifier for the checkbox.
 * @param {string} [props.className] - Additional class names for styling.
 * @param {string} [props.name] - Name attribute for the checkbox input.
 * @param {boolean} [props.grey] - If true, applies grey styling.
 * @param {boolean} [props.circle] - If true, renders the checkbox as a circle.
 * @param {string} [props.label] - Label text for the checkbox.
 * @param {any} [props.value] - Value of the checkbox.
 * @param {boolean} [props.required] - If true, marks the checkbox as required.
 * @param {boolean} [props.disabled] - If true, disables the checkbox.
 * @param {function} [props.onChange] - Callback function triggered on change.
 * @param {boolean} [props.defaultChecked] - Initial checked state of the checkbox.
 * @param {string} [props.color] - Color for the checkbox when checked.
 * @param {Object} [props.props] - Additional props to be passed to the input.
 */
const CheckBox = ({
  id,
  className,
  name,
  grey,
  circle,
  label,
  value,
  required = false,
  disabled,
  onChange,
  defaultChecked = false,
  color = "var(--secondary)",
  ...props
}) => {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(defaultChecked);
  }, [defaultChecked]);

  return (
    <Wrapper className="flexRow alignCenter checkBox">
      <Box
        grey={grey}
        circle={circle}
        checked={checked}
        onClick={(e) => handleClick(e, id)}
        className={className}
        color={color}
      >
        <input
          type="checkbox"
          name={name}
          id={`${id}`}
          checked={checked}
          value={value}
          onChange={(e) => {
            onChange && onChange(e);
            setChecked(!checked);
          }}
          required={required}
          disabled={disabled}
          {...props}
        />
        <img src={doneIconWhite} alt="check" className="checkedIcon" />
      </Box>
      {label && (
        <label htmlFor={`${id}`} className="l3 ellipsify">
          {label}
        </label>
      )}
    </Wrapper>
  );
};

CheckBox.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any,
  label: PropTypes.string,
  grey: PropTypes.bool,
  circle: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default CheckBox;
